// extracted by mini-css-extract-plugin
var _1 = "RentalPortalProfileHeaderFooterAddNewText-moduleRentalPortalProfileHeaderFooterAddNewText__KVObJ";
export { _1 as "RentalPortalProfileHeaderFooterAddNewText" }
